import React from 'react'
import { Dialog } from '@progress/kendo-react-dialogs'
import { createPortal } from 'react-dom'
import CLOSE_ICON from '@public/assets/close_dialog.svg'
import DIALOG_BAR_IMAGE from '@public/assets/common/dialog_confirmational.svg'
import '@css/RestoreActivitiesDialog.css'

interface RestoreActivitiesDialogProps {
  isMobile: boolean
  onClose: () => void
  onRestoreAll: () => void | Promise<void>
  onRestoreOne: () => void | Promise<void>
  sourceName: string
}

export function RestoreActivitiesDialog({
  isMobile,
  onClose,
  onRestoreAll,
  onRestoreOne,
  sourceName,
}: RestoreActivitiesDialogProps) {
  const restoreAllButton = (
    <button
      className="restore-activities-button restore-activities-button-primary"
      onClick={() => void onRestoreAll()}
      type="button"
    >
      Restore all
    </button>
  )
  const restoreOneButton = (
    <button
      className="restore-activities-button restore-activities-button-secondary"
      onClick={() => void onRestoreOne()}
      type="button"
    >
      Only restore this one
    </button>
  )

  return createPortal(
    <Dialog
      className={`restore-activities-dialog ${isMobile ? 'mobile-restore-activities-dialog' : ''}`}
      onClose={onClose}
    >
      <div
        onClick={event => event.stopPropagation()}
        onMouseEnter={event => event.stopPropagation()}
        onMouseLeave={event => event.stopPropagation()}
        onMouseMove={event => event.stopPropagation()}
      >
        <button
          className="restore-activities-close"
          onClick={onClose}
          type="button"
        >
          <img alt="Close" src={CLOSE_ICON} />
        </button>
        <div className="restore-activities-card">
          <div className="restore-activities-image">
            <img alt="" src={DIALOG_BAR_IMAGE} />
          </div>
          <div className="restore-activities-content">
            <h2>Restore Activities?</h2>
            <p>
              {isMobile
                ? `Would you like to restore all associated activities for this ${sourceName}?`
                : `This ${sourceName} activity appears multiple times throughout your day. Do you want to restore all related activities to billable, or just this one?`}
            </p>
          </div>
          <div className="restore-activities-footer">
            {isMobile ? (
              <>
                {restoreAllButton}
                {restoreOneButton}
              </>
            ) : (
              <>
                {restoreOneButton}
                {restoreAllButton}
              </>
            )}
          </div>
        </div>
      </div>
    </Dialog>,
    document.body
  )
}
